import ajaxCrud from "./ajaxCrud";
import { endpointImpostazioniEvento } from "../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointImpostazioniEvento, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointImpostazioniEvento, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointImpostazioniEvento, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointImpostazioniEvento, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointImpostazioniEvento, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointImpostazioniEvento, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointImpostazioniEvento, rows, cb);
  },
};
